import React from 'react';
import PropTypes from 'prop-types';
import { useDownloadDocumentMutation } from '../../../data/document';
import { downloadPdfFile } from '../../../helpers/docHelpers';
import { getGtmService } from '../../../services/gtmService/GtmService';
import { legacyPolicyNumberHandler } from '../../../helpers/paymentHelper';

export const PetDownloadButton = ({ policyNumber, attachmentId, fileName, docType, auth0Token }) => {
  const [downloadDocument] = useDownloadDocumentMutation();

  const handleDownload = async () => {
    try {
      await downloadPdfFile(
        downloadDocument,
        { policyNumber: legacyPolicyNumberHandler(policyNumber), attachmentId, auth0Token },
        fileName
      );

      const gtm = getGtmService();
      gtm.pushDocumentDownload(docType, policyNumber);
    } catch (error) {
      throw new Error(error);
    }
  };

  return (
    <button
      className="button primary text_only"
      onClick={handleDownload}
      type="button"
    >
      <span className="labelText">Correspondence</span>
    </button>
  );
};

PetDownloadButton.propTypes = {
  policyNumber: PropTypes.string.isRequired,
  attachmentId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  fileName: PropTypes.string.isRequired,
  docType: PropTypes.string,
  auth0Token: PropTypes.string
};
